// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__rPrIC","flag":"Modal_flag__X8HM+","content":"Modal_content__+C9Xp"};